import cn from "@/v2-ui/utils/utils.cn"
import Button from "@/v2-backoffice-client/components/button"

interface SettingOptionGroupProps<T extends string | number> {
  options: readonly { value: T; label: string }[]
  value: T
  onChange: (value: T) => void
}

function SettingOptionGroup<T extends string | number>({
  options,
  value,
  onChange,
}: SettingOptionGroupProps<T>) {
  return (
    <div className="flex items-center gap-1 p-1 rounded-md bg-muted w-fit">
      {options.map((opt) => {
        const isActive = value === opt.value
        return (
          <Button
            key={opt.value}
            size="sm"
            variant={isActive ? "primary" : "ghost"}
            className={cn("h-7 px-3 text-xs transition-none", {
              "bg-primary text-primary-foreground hover:bg-primary/90":
                isActive,
            })}
            onClick={() => {
              onChange(opt.value)
            }}
          >
            {opt.label}
          </Button>
        )
      })}
    </div>
  )
}

export default SettingOptionGroup
